import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
import editReducer from "./reducers/editReducer";
import formStatusReducer from "./reducers/formStatusReducer";
import headerReducer from "./reducers/headerReducer";
import sliderReducer from "./reducers/sliderReducer";
import settingsReducer from "./reducers/settingsReducer";
import announcementsReducer from "./reducers/announcementsReducer";
import statisticsReducer from "./reducers/statisticsReducer";
import leadershipBoardReducer from "./reducers/leadershipBoardReducer";
import reportsReducer from "./reducers/reportsReducer";
import liveCoursesReducer from "./reducers/liveCoursesReducer";
import accessTokenReducer from "./reducers/accessTokenReducer";
import searchReducer from "./reducers/searchReducer";
import advancedSearchReducer from "./reducers/advancedSearchReducer";
import calendarMonthReducer from "./reducers/calendarMonthReducer";
import subjectsReducer from "./reducers/subjectsReducer";
import sessionTimingsReducer from "./reducers/sessionTimingsReducer";
import classesReducer from "./reducers/classesReducer";
import tutorsReducer from "./reducers/tutorsReducer";
import studentsReducer from "./reducers/studentsReducer";
import approvalReducer from "./reducers/approvalReducer";
import degreeReducer from "./reducers/degreeReducer";
import specificationReducer from "./reducers/specificationReducer";
import examScheduleReducer from './reducers/examSchedule';
import dashboardReducer from './reducers/dashboardReducer';
import reportsStudentReducer from './reducers/reportsStudentReducer';
import reportsTutorReducer from './reducers/reportsTutorReducer';
import studentStatisticsReducer from './reducers/studentStatisticsReducer';
import studentExamScheduleReducer from './reducers/studentExamScheduleReducer';
import studentExamScheduleStatsReducer from './reducers/studentExamScheduleStatsReducer';

import tutorStatisticsReducer from './reducers/tutorStatisticsReducer';
import tutorExamScheduleReducer from './reducers/tutorExamScheduleReducer';
import tutorExamScheduleStatsReducer from './reducers/tutorExamScheduleStatsReducer';
import scheduleReducer from "./reducers/scheduleReducer";


import statisticsParticipantReducer from './reducers/statisticsParticipantReducer';
import attendanceReducer from "./reducers/attendanceReducer";
import attendanceReportReducer from "./reducers/attendanceReportReducer";
import attendanceAllReducer from "./reducers/attendanceAllReducer";
import attendanceDataReducer from "./reducers/attendanceDataReducer";

const rootReducer = combineReducers({
    sliderState: sliderReducer,
    headerState: headerReducer,
    formStatus: formStatusReducer,
    editState: editReducer,
    settingsState: settingsReducer,
    announcementsState: announcementsReducer,
    statisticsState: statisticsReducer,
    leadershipBoardState: leadershipBoardReducer,
    reportsState: reportsReducer,
    liveCoursesState: liveCoursesReducer,
    accessTokenState: accessTokenReducer,
    searchState: searchReducer,
    advancedSearchState: advancedSearchReducer,
    calendarMonthState: calendarMonthReducer,
    subjectsState: subjectsReducer,
    sessionTimingsState: sessionTimingsReducer,
    classesState: classesReducer,
    specificationState: specificationReducer,
    examScheduleState: examScheduleReducer,
    degreeState: degreeReducer,
    tutorsState: tutorsReducer,
    studentsState: studentsReducer,
    approvalState: approvalReducer,
    dashboardState: dashboardReducer,
    studentsData:reportsStudentReducer,
    TutorsData:reportsTutorReducer,
    studentStatisticsData:studentStatisticsReducer,
    studentExamScheduleData:studentExamScheduleReducer,
    tutorStatisticsData:tutorStatisticsReducer,
    tutorExamScheduleData:tutorExamScheduleReducer,
    studentExamScheduleStatsData:studentExamScheduleStatsReducer,
    TutorExamScheduleStatsData:tutorExamScheduleStatsReducer,
    statisticParticipantsData: statisticsParticipantReducer,
    scheduleState: scheduleReducer,
    attendanceState: attendanceReducer,
    attendanceReportsState: attendanceReportReducer,
    attendanceAllState: attendanceAllReducer,
    attendanceDataState: attendanceDataReducer
});

export const store = createStore(rootReducer, applyMiddleware(thunk))